export enum LOCALE_CODES {
  NO = 'no',
  EN = 'en',
  SV = 'sv',
  DA = 'da'
}

export const translations = {
  [LOCALE_CODES.EN]: {
    errors: {
      unexpected: 'An unexpected error occurred.',
      notFound: 'The requested benefits could not be found.'
    },
    poweredByPurpose: 'Powered by Purpose IT'
  },
  [LOCALE_CODES.DA]: {
    errors: {
      unexpected: 'Der opstod en uventet fejl.',
      notFound: 'De ønskede fordele kunne ikke findes.'
    },
    poweredByPurpose: 'Drevet af Purpose IT'
  },
  [LOCALE_CODES.NO]: {
    errors: {
      unexpected: 'Det oppstod en uventet feil.',
      notFound: 'De forespurte fordelene ble ikke funnet.'
    },
    poweredByPurpose: 'Drevet av Purpose IT'
  },
  [LOCALE_CODES.SV]: {
    errors: {
      unexpected: 'Ett oväntat fel har uppstått.',
      notFound: 'De efterfrågade förmånerna kunde inte hittas.'
    },
    poweredByPurpose: 'Drivs av Purpose IT'
  }
};
